'use strict';

import Backbone from 'backbone';
import _ from 'underscore';
import $ from 'jquery';
import Masonry from 'masonry';
import {parallelArrayEach} from '../../utilities/uiLoopHelpers';
import mediator from '../../js/mediator';
import config from '../../js/config';
import utils from '../../js/utilities';
import Analytics from '../../components/Analytics/Analytics';
import { EnableAdobeAnalytics } from '../../utilities/featureFlags';
var paginationTemplate = require('./templates/_MasonryPagination.hbs');
export default class MasonryGridView extends Backbone.View {
  get events() {
    return {
      'click .Button--loadMore': 'loadMore',
      'click .Masonry-pagination a': 'changePage',
      'click .InformationTile-psuedoLink': 'pushInformationToAdobe'
    };
  }

  initialize(options) {
    this.$masonryWrapper = this.$('.Masonry-grid');
    this.ajaxUrl = this.$masonryWrapper.data('url');
    this.postParams = this.$masonryWrapper.data('post-parameters');
    this.paginatedGrid = false;
    this.loadMoreListLength = 0;
    // Initialise ajax parameters
    this.ajaxParams = {
      page: 2 // on init we are already on 1 (rendered by backend)
    };

    _.extend(this.ajaxParams, options.ajaxParams);

    this.masonry = new Masonry(this.$masonryWrapper[0], {
      columnWidth: '.Masonry-gridSizer',
      itemSelector: '.Masonry-item',
      percentPosition: true,
      transitionDuration: '2s'
    });

    // Resize masonry on event
    mediator.on(config.events.masonry.resize, () => {
      this.masonry.resize();
    }, this);

    //Initialize pagination
    this.initializePagination();

  }

  initializePagination() {
    let $paginationContainer = this.$('.Masonry-pagination-container');
    if ($paginationContainer.length) {
      this.paginatedGrid = true;
      this.currentPage = 1;
      this.totalPageCount = $($paginationContainer[0]).data('itemCount');
      let page = this.getUrlParameter('page');
      if (page) {
        this.currentPage = page;
        this.loadMore();
      }

      this.$pagination = this.$('.Masonry-pagination');
      this.renderPagination(this.totalPageCount, this.currentPage);
    }
  }

  renderPagination(totalPageCount, currentPage) {
    totalPageCount = totalPageCount || 1;
    var pagination = {
      current: currentPage,
      totalPageCount
    };

    pagination.analyticsConfig = config.analytics;
    pagination.firstPageUrl = window.location.href.split('?')[0];

    this.$pagination.html(paginationTemplate(pagination));

  }

  changePage(e) {
    e.preventDefault();
    this.currentPage = parseInt($(e.currentTarget).data('gtmLabel'));
    this.loadMore();
  }

  updateQueryStringParam(key, value) {
    let baseUrl = [location.protocol, '//', location.host, location.pathname].join(''),
      urlQueryString = document.location.search,
      newParam = key + '=' + value,
      params = '?' + newParam;

    if (urlQueryString) {
      let keyRegex = new RegExp('([\?&])' + key + '[^&]*');
      if (urlQueryString.match(keyRegex) !== null) {
        params = urlQueryString.replace(keyRegex, '$1' + newParam);
      } else {
        params = urlQueryString + '&' + newParam;
      }
    }

    if (value === 1) {
      window.history.replaceState({}, '', baseUrl);
    } else {
      window.history.replaceState({}, '', baseUrl + params);
    }
  };

  requestData() {
    let method = 'GET';
    let url = utils.queryStringUrl(this.ajaxUrl, this.ajaxParams);
    if (this.paginatedGrid) {
      this.ajaxParams.page = this.currentPage;
    }
    let data = this.ajaxParams;

    // If we had post params, we want a post instead
    if (this.postParams) {
      method = 'POST';
      url = this.ajaxUrl;
      data = $.param(this.ajaxParams, true) + '&' + this.postParams;
    }

    return $.ajax({
      dataType: 'json',
      method: method,
      url: url,
      data: utils.addCustIpToDataObject(data)
    });
  }

  // Load more element in the Masonry grid
  loadMore(el) {
    if (el && !this.paginatedGrid) {
      this.loadMoreListLength = this.$masonryWrapper ? this.$masonryWrapper.find('.Masonry-item').length : 0;
      let clicked = $(el.currentTarget);
      if (!this.ajaxUrl || this.noMore || clicked.hasClass(config.classes.isDisabled)) return;

      clicked.addClass(config.classes.isDisabled);

      this.requestData().done(res => {
        this.onLoadMoreAjaxSuccess(res);
        clicked.removeClass(config.classes.isDisabled);
      });
    } else {
      this.requestData().done(res => {
        this.onLoadMoreAjaxSuccess(res);
      });
    }
  }

  onLoadMoreAjaxSuccess(res) {
    if (this.paginatedGrid) {
      this.renderPagination(this.totalPageCount, this.currentPage);
      this.updateQueryStringParam('page', this.currentPage);
    }
    this.addContent(res.content, res.hasMore);
  }

  ajaxRefresh(ajaxParams) {
    if (!this.ajaxUrl) return;

    // Add params passed to the functions to the object one
    _.extend(this.ajaxParams, ajaxParams);

    // Always load the first page when it's a refresh
    this.ajaxParams.page = 1;

    this.requestData().done(this.onAjaxRefreshSuccess.bind(this));
  }

  getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
      sURLVariables = sPageURL.split('&'),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split('=');

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined ? true : sParameterName[1];
      }
    }
  }

  onAjaxRefreshSuccess(res) {
    // Remove elements
    this.masonry.remove(this.$masonryWrapper.find('.Masonry-item'));
    this.$el.removeClass('is-empty');
    this.masonry.layout();

    // If there is no content
    if (!res.content) {
      this.$el.addClass('is-empty');
      return;
    }

    this.addContent(res.content, res.hasMore);
  }

  addContent(html, hasMore) {
    if (html) {
      let $html = $(html);
      // Append content using Masonry to keep layout
      if (this.paginatedGrid) {
        this.masonry.remove(this.$masonryWrapper.find('.Masonry-item'));
        this.$el.removeClass('is-empty');
        this.masonry.layout();
        this.masonry.appended($html.appendTo(this.$masonryWrapper));
      } else {
        this.masonry.appended($html.appendTo(this.$masonryWrapper));
        this.ajaxParams.page++;
      }
      var firstAddedElement = this.$masonryWrapper && this.$masonryWrapper.find('.Masonry-item');
      if (firstAddedElement && firstAddedElement.length)
      {
        if (firstAddedElement.length !== this.loadMoreListLength) {
          firstAddedElement = firstAddedElement && firstAddedElement.eq(this.loadMoreListLength);
          firstAddedElement.find('.InformationTile-psuedoLink').focus();
        } else {
          firstAddedElement = firstAddedElement && firstAddedElement.eq(this.loadMoreListLength - 1);
          firstAddedElement.find('.InformationTile-psuedoLink').focus();
        }
      }

      mediator.trigger(config.events.ui.ajaxContentLoaded, $html);
    }

    // Hide or show load more button depending on the parameter value
    this.noMore = !hasMore;
    this.$('.Button--loadMore').toggleClass('is-hidden', this.noMore);
  }

  pushInformationToAdobe(e) {
    e.preventDefault()
    if (EnableAdobeAnalytics.isEnabled()) {
      let tags = []
      let $tags = $(e.currentTarget).find('.Tags-item-text')
      $(e.currentTarget.offsetParent).find('.Tags-item-text').each(function() {
        tags.push($(this).text().trim());
      });
      const adobeData = {
        event: 'article_interaction',
        articleTitle: e.currentTarget.dataset.gtmLabel || undefined,
        articleTags: tags
      }
      Analytics.setOnAdobeDataLayer(adobeData);
    }
    const href = $(e.currentTarget).attr('href');
    window.location.href = href;
  }
}

export function createMasonryGridView($parent) {
  // Need to exclude filterable ones because the need to be created and linked with a tag filter
  let $masonrys = $parent.find('.Masonry:not(.Masonry--filterable)')
    .filter((n, el) => $(el).find('.Masonry-grid').length);
  parallelArrayEach($masonrys, el => new MasonryGridView({ el }));
}


// WEBPACK FOOTER //
// ./assets/components/MasonryGridView/MasonryGridView.js